import validate from "/home/runner/work/hokify/hokify/node_modules/.pnpm/nuxt@3.15.1_@types+node@20.17.47_eslint@8.57.1_sass@1.44.0_tsx@4.19.4_typescript@5.8.3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/hokify/hokify/node_modules/.pnpm/nuxt@3.15.1_@types+node@20.17.47_eslint@8.57.1_sass@1.44.0_tsx@4.19.4_typescript@5.8.3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}